/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TextToSpeechHistoryObject,
  TextToSpeechHistoryObject$inboundSchema,
  TextToSpeechHistoryObject$Outbound,
  TextToSpeechHistoryObject$outboundSchema,
} from "./texttospeechhistoryobject.js";

/**
 * A paginated list of text-to-speech history items.
 */
export type TextToSpeechHistoryList = {
  object: "list";
  data: Array<TextToSpeechHistoryObject>;
  firstId?: string | undefined;
  lastId?: string | undefined;
  hasMore: boolean;
};

/** @internal */
export const TextToSpeechHistoryList$inboundSchema: z.ZodType<
  TextToSpeechHistoryList,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(TextToSpeechHistoryObject$inboundSchema),
  first_id: z.string().optional(),
  last_id: z.string().optional(),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type TextToSpeechHistoryList$Outbound = {
  object: "list";
  data: Array<TextToSpeechHistoryObject$Outbound>;
  first_id?: string | undefined;
  last_id?: string | undefined;
  has_more: boolean;
};

/** @internal */
export const TextToSpeechHistoryList$outboundSchema: z.ZodType<
  TextToSpeechHistoryList$Outbound,
  z.ZodTypeDef,
  TextToSpeechHistoryList
> = z.object({
  object: z.literal("list"),
  data: z.array(TextToSpeechHistoryObject$outboundSchema),
  firstId: z.string().optional(),
  lastId: z.string().optional(),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function textToSpeechHistoryListToJSON(
  textToSpeechHistoryList: TextToSpeechHistoryList,
): string {
  return JSON.stringify(
    TextToSpeechHistoryList$outboundSchema.parse(textToSpeechHistoryList),
  );
}
export function textToSpeechHistoryListFromJSON(
  jsonString: string,
): SafeParseResult<TextToSpeechHistoryList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TextToSpeechHistoryList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TextToSpeechHistoryList' from JSON`,
  );
}
